import logo from "./Logo.png";
import Avatar from "./Avatar/Avatar";
import "./App.css";

function App() {
  const urlParams = new URLSearchParams(window.location.search);
  const paramValue = urlParams.get("dialerUrl");
  return (
    <div className="App">
      <iframe
        style={{ width: "50%", height: "100%" }}
        src={
          paramValue
            ? paramValue
            : "https://felg2.dialerhosting.com/agc/vicidial.php"
        }
        allow="camera;microphone"
        title="FE Dailer"
      ></iframe>

      <div style={{ width: "50%", height: "100%" }}>
        <header className="App-header">
          <p
            style={{
              color: "wheat",
              fontSize: 22,
              fontFamily: "serif",
              paddingLeft: "10px 0px",
            }}
          >
            FE Avatar
          </p>
          <img src={logo} className="App-logo" alt="logo" />

          <p
            style={{
              color: "wheat",
              fontSize: 22,
              fontFamily: "serif",
              margin: "0px 10px",
            }}
          >
            Agent Avatar
          </p>
        </header>

        <section className="App-content">
          <Avatar />
        </section>

        <footer className="App-footer">
          <a
            href="http://allstarbpo.com/"
            style={{ color: "white", fontWeight: "bold" }}
            target="_blank"
            rel="noopener noreferrer"
          >
            Copyright {new Date().getFullYear()} © Star Software Solutions
          </a>
        </footer>
      </div>
    </div>
  );
}

export default App;
